<template>
  <nav
    class="flex fixed w-full items-center justify-between px-6 h-16 bg-white text-gray-700 border-b border-gray-200 z-10"
  >
    <div class="flex items-center">
      <button class="mr-2" aria-label="Open Menu" @click="drawer">
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          class="w-8 h-8"
        >
          <path d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
      <img
        :src="`${publicPath}images/apple-touch-icon.png`"
        alt="Logo"
        class="h-auto w-8 mr-2"
      />
      <!-- <svg
        class="fill-current h-8 w-8 mr-2"
        width="54"
        height="54"
        viewBox="0 0 54 54"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"
        />
      </svg> -->
      <span class="font-semibold text-xl tracking-tight">Dimrill</span>
    </div>
    <div class="flex space-x-2">
      <button-with-dropdown :user="user"></button-with-dropdown>
    </div>

    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out transition-medium"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="ease-out transition-medium"
      leave-to-class="opacity-0"
    >
      <div
        @keydown.esc="isOpen = false"
        v-show="isOpen"
        class="z-10 fixed inset-0 transition-opacity"
      >
        <div
          @click="isOpen = false"
          class="absolute inset-0 bg-black opacity-50"
          tabindex="0"
        ></div>
      </div>
    </transition>
    <aside
      class="transform top-0 left-0 w-64 bg-white fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30"
      :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
    >
      <span
        @click="isOpen = false"
        class="flex w-full items-center p-4 border-b"
      >
        <img
          :src="`${publicPath}images/apple-touch-icon.png`"
          alt="Logo"
          class="h-auto w-8 mr-8"
        />
        <span>Dimrill</span>
      </span>
      <!-- <router-link
        :to="{ name: 'Dashboard One' }"
        v-on:click.native="isOpen = false"
        class="flex items-center p-4 hover:bg-indigo-500 hover:text-white"
      >
        <span class="mr-2">
          <svg
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            class="w-6 h-6"
          >
            <path
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            ></path>
          </svg>
        </span>
        One
      </router-link> -->
      <a
        :href="`${baseBigMLURL}/dashboard/sources`"
        target="_blank"
        rel="nofollow noopener noreferrer"
        class="flex items-center p-4 hover:bg-green-500 hover:text-white"
      >
        BigML Sources
        <span class="ml-2">
          <svg
            fill="currentColor"
            stroke="none"
            viewBox="0 0 24 24"
            class="w-6 h-6"
          >
            <path
              d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
            ></path>
          </svg>
        </span>
      </a>
    </aside>
  </nav>
</template>

<script>
/* const GENDERS = ["men", "women"];
const INDEXES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const randItem = items => {
  return items[(items.length * Math.random()) | 0];
}; */

import ButtonWithDropdown from "@/components/ButtonWithDropdown";

export default {
  components: {
    ButtonWithDropdown
  },
  data() {
    return {
      isOpen: false,
      user: null,
      publicPath: process.env.BASE_URL,
      baseBigMLURL: process.env.VUE_APP_BIGML_UI_BASE_URL
    };
  },
  computed: {
    defaultAvatar() {
      return `${this.publicPath}/images/default-avatar-300x300.png`;
    }
  },
  methods: {
    drawer() {
      this.isOpen = !this.isOpen;
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (process.client) {
          if (isOpen) document.body.style.setProperty("overflow", "hidden");
          else document.body.style.removeProperty("overflow");
        }
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode === 27 && this.isOpen) this.isOpen = false;
    });
  },
  created() {
    const ioCredentials = this.$store.getters["auth/IO_AUTH"];
    this.user = {
      avatar: this.defaultAvatar,
      username: ioCredentials.username
    };
    // Simulate fetching user data.
    /* setTimeout(() => {
      this.user = {
        avatar: `https://randomuser.me/api/portraits/${randItem(
          GENDERS
        )}/${randItem(INDEXES)}.jpg`,
        name: `John Doe`,
        notifications: {
          has: randItem([true, false]),
          color: randItem(["green", "red"])
        }
      };
    }, 3000); */
  }
};
</script>

<style scoped>
aside a.active {
  --bg-opacity: 0.8;
  background-color: #667eea;
  background-color: rgba(102, 126, 234, var(--bg-opacity));
}
</style>
